export const TOAST_TEXT = {
  close: '닫기',
  region: '알림',
} as const;
